import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { CustomApiHandler } from "@tSurya/Store/CustomHandlerCreator/CustomHandlerCreator";

type Parameter = {
    filterModal: boolean;
};

export const DispatchSetFilterModal: CustomApiHandler<Parameter, boolean> = props => {
    props.dispatch({
        type: "Custom/ProductList/SetFilterModal",
        result: props.parameter.filterModal,
    });
};

export const chain = [DispatchSetFilterModal];

const filterDrawer = createHandlerChainRunner(chain, "filterModal");
export default filterDrawer;
